var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceaischenegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_aische_negative_svg__a",
    d: "M0 152.666C0 68.866 67.943.933 151.743.933c83.805 0 151.742 67.947 151.742 151.733v28.342c0 83.8-45.62 202.083-101.907 264.166 0 0-42.664 47.171-42.91 47.171-4.864 0-52.775-50.938-52.775-50.938C47.41 381.393 0 264.794 0 181.008v-28.342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_aische_negative_svg__c",
    d: "M.33 120.541C.33 53.966 54.3-.004 120.867-.004c66.57 0 120.536 53.967 120.536 120.545v26.087c0 66.575-53.483 127.719-119.457 136.568l-1.079.145-1.078-.145C53.813 274.346.33 213.206.33 146.628v-26.087z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.571 22.344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_aische_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_aische_negative_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 14,
    d: "M151.714-6.067c43.845-.008 83.54 17.763 112.273 46.494 28.73 28.727 46.498 68.412 46.498 112.24h0v28.341c0 85.292-46.432 205.68-103.715 268.862 0 0-10.567 10.929-21.796 22.514l-1.436 1.482-.72.742-1.438 1.483c-11.496 11.855-22.584 23.254-22.713 23.254-4.336 0-41.658-36.927-53.965-49.223l-1.582-1.582c-1.4-1.401-2.231-2.24-2.328-2.337C41.252 385.036-7 266.325-7 181.008h0v-28.342c0-43.357 17.386-82.654 45.565-111.302C66.8 12.66 105.872-5.352 149.15-6.046h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15165",
    stroke: "#363A4F",
    strokeLinecap: "round",
    strokeWidth: 14.171,
    d: "M151.714-6.152c43.868-.008 83.585 17.772 112.334 46.518 28.744 28.743 46.523 68.45 46.523 112.3h0v28.342c0 85.31-46.442 205.723-103.738 268.919 0 0-11.975 12.376-23.983 24.752l-1.44 1.484c-11.512 11.862-22.614 23.268-22.743 23.268-4.39 0-42.563-37.798-54.437-49.661l-1.157-1.157c-1.403-1.405-2.24-2.248-2.342-2.35C41.178 385.081-7.086 266.342-7.086 181.007h0v-28.342c0-43.38 17.396-82.699 45.59-111.362 28.25-28.72 67.343-46.741 110.644-47.436h0z",
    mask: "url(#face_aische_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M74.801 15.89S295.211.024 295.211 154.938c0 154.914-110.205 327.559-110.205 327.559l105.455-154.914 33.252-184.777-33.252-101.72-80.753-45.728-105.455-7.466L74.8 15.889zM44.44 277.19s47.503 79.323 105.456 83.99C56.79 363.98 44.44 277.19 44.44 277.19z",
    mask: "url(#face_aische_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M209.748 360.246S198.266 447.97 164.146 471.3c50.271-29.863 45.602-111.053 45.602-111.053z",
    mask: "url(#face_aische_negative_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.723 103.123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_aische_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_aische_negative_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#face_aische_negative_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 14,
    d: "M120.894 6.996c31.342.008 59.715 12.715 80.255 33.256 20.546 20.547 33.253 48.933 33.253 80.29h0v26.086c0 31.597-12.747 61.875-33.257 85.323-20.51 23.447-48.82 40.107-80.13 44.307-31.608-4.2-59.919-20.86-80.428-44.307-20.51-23.447-33.256-53.725-33.256-85.323h0v-26.087c0-31.014 12.434-59.124 32.589-79.616C60.102 20.404 88.027 7.52 118.959 7.012h0z",
    mask: "url(#face_aische_negative_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M40.862 39.52s212.206-58.68 185.561 131.8l25.693-37.915L201.682-.2 98.909-9.23 35.152 19.66l5.71 19.86z",
    mask: "url(#face_aische_negative_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 9.92,
    d: "M284.896 214.348c-7.589-8.935-24.024-7.652-36.709 2.865M128.57 214.348c7.589-8.935 24.024-7.652 36.709 2.865"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.952,
    d: "M193.773 276.204c0 6.959 5.741 12.6 12.823 12.6h0c7.083 0 12.824-5.641 12.824-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.696,
    d: "M261.31 238.323c0-5.104 4.018-9.24 8.976-9.24h0c4.957 0 8.976 4.136 8.976 9.24M134.786 238.323c0-5.104 4.019-9.24 8.976-9.24 4.958 0 8.976 4.136 8.976 9.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.944,
    d: "M182.815 319.127c3.73-4.147 14.726-9.216 26.26-9.216 11.587 0 23.328 5.384 26.26 9.911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M196.668 273.53s12.35 2.8 12.35-21.463c0-24.264 9.501 23.33 9.501 23.33l-4.75 12.132-11.4.933-4.75-4.666-.95-10.265z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceaischenegative);
export default __webpack_public_path__ + "static/media/face.aische.negative.0e5fbc16.svg";
export { ForwardRef as ReactComponent };